import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetOrgUserInvitationById = (apidata) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
        },
        url: `${actionType.environment_url}/api/GetOrgUserInvitationById`,
        params: {invite_id:apidata}
      });
      return response.data
    } catch (error) {
      return error.message
    }
  };